import React from "react";
import { Link, useLocation } from "react-router-dom";

export const Navigation = (props) => {
  const location = useLocation();
  const isPrivacyPage = location.pathname === '/privacy-policy';

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Link className="navbar-brand page-scroll" to="/">
          ReCopilot
          </Link>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
          <li>
              {isPrivacyPage ? (
                <Link to="/#about" className="page-scroll">
                  About
                </Link>
              ) : (
                <a href="#about" className="page-scroll">
                  About
                </a>
              )}
            </li>
            <li>
              {isPrivacyPage ? (
                <Link to="/#features" className="page-scroll">
                  Features
                </Link>
              ) : (
                <a href="#features" className="page-scroll">
                  Features
                </a>
              )}
            </li>
            {/* <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li> */}
            <li>
              {isPrivacyPage ? (
                <Link to="/#our-services" className="page-scroll">
                  Services
                </Link>
              ) : (
                <a href="#our-services" className="page-scroll">
                  Services
                </a>
              )}
            </li>
            <li>
              {isPrivacyPage ? (
                <Link to="/#Testimonials" className="page-scroll">
                  Clients
                </Link>
              ) : (
                <a href="#Testimonials" className="page-scroll">
                  Clients
                </a>
              )}
            </li>
            <li>
              {isPrivacyPage ? (
                <Link to="/#team" className="page-scroll">
                  Team
                </Link>
              ) : (
                <a href="#team" className="page-scroll">
                  Team
                </a>
              )}
            </li>
            <li>
              {isPrivacyPage ? (
                <Link to="/#contact" className="page-scroll">
                  Contact
                </Link>
              ) : (
                <a href="#contact" className="page-scroll">
                  Contact
                </a>
              )}
            </li>
            <li>
              <Link to="/privacy-policy" className="page-scroll">
                プライバシーポリシー
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
